import React, { MouseEventHandler } from 'react';
import css from './index.module.css';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface ButtonProps {
  label: string;
  className?: string;
  icon?: IconDefinition;
  iconAfterWord?: boolean;
  type?: 'button' | 'submit' | 'reset';
  handleClick?: MouseEventHandler<HTMLButtonElement>;
  iconAfterImg?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  className,
  icon,
  iconAfterWord = false,
  type = 'button',
  handleClick,
  iconAfterImg,
}) => {
  const { t } = useTranslation();

  const iconElement = icon ? (
    <FontAwesomeIcon icon={icon} />
  ) : iconAfterImg ? (
    <img src={iconAfterImg} alt="icon" width={23} height={23} />
  ) : (
    ''
  );
  let combinedClasses = `${css.button} `;
  const classes = className?.split(' ');

  classes?.forEach((string) => {
    const cssClass = css[string] ? css[string] : string;

    combinedClasses += cssClass + ' ';
  });

  return (
    <button className={combinedClasses} type={type} onClick={handleClick}>
      {!iconAfterWord && iconElement}
      <span> {t(label)} </span>
      {iconAfterWord && iconElement}
    </button>
  );
};

export default Button;
